module.exports = __webpack_public_path__ + "static/img/life-proposal5.ca3fed2d.png";